<template>
    <div>
        <!--新增Share弹框-->
        <el-dialog class="shareDialog" :title="$t('ShareManagement')" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false" 
            :visible.sync="addShare.addShareFrom" 
            center 
            :show-close="addShare.showClose" 
        >
            <div class="addsiteUersBox" v-show="addShare.shareType === 1">
                <div style="width: 80%;">
                    <div>{{$t('WantToShare')}}</div>
                    <div class="searchInputBox">
                        <el-input v-model="addShare.searcUserAccount"></el-input>
                        <img class="searchImg" @click="searchUserInfo" :src="shareList.search" alt="">
                    </div>
                    <div class="accountInfo" v-show="addShare.searchHasAcc === 1">
                        <span :title="addShare.userAccount">{{addShare.userAccount}}</span>
                        <span style="color: #ccc;" :title="addShare.nickNam">{{$t('Alias') + ' : ' + addShare.nickNam}}</span>
                        <div :disabled="addShare.addBtnState === 1"><img class="shareImg" @click="shareHouseTo" :src="shareList.share" alt=""></div>
                    </div>
                    <div class="accountNotExit" v-show="addShare.searchHasAcc === 2">
                        {{ $t('AccountNotExist') }}
                    </div>
                </div>
            </div>
            <!-- 二维码和邀请链接分享暂时不做 -->
            <div v-if="false" v-show="addShare.shareType === 1" slot="footer" class="dialog-footer addCard">
                <p class="moreWays"><a href="#" @click="moreWaysShare">More ways to share</a></p>
            </div>
            <div class="addsiteUersBox" v-show="addShare.shareType === 2">
                <div style="width: 80%;">
                   <div class="QRCodeBox">
                        <h3 style="text-align: center;margin-bottom: 15px;">{{ $t('QRCode') }}</h3>
                        <div class="QRCodeBoxDiv">
                            <div class="QRCodeBoxLeft">{{ $t('ScanQRCodeFriend') }}</div>
                            <div class="QRCodeBoxRight" ref="shareQRCodeBox"></div>
                        </div>
                   </div>
                   <div class="LinkBox">
                        <h3 style="text-align: center;margin-bottom: 15px;">{{ $t('Link') }}</h3>
                        <div class="LinkBoxBoxDiv">
                            <span>{{ $t('FriendsFamily') }}</span> <span><a href="#">{{ $t('ShareLink') }}</a>  </span>
                        </div>
                   </div>
                </div>
            </div>
        </el-dialog>
        <!--取消Share弹框-->
        <el-dialog
            :title="$t('Delete')"
            :visible.sync="delShare.delShareFrom"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="500px"
            :show-close="delShare.showClose">
            <p class="deleteDesc">{{$t('ConfirmDeleteShare')}}</p>
            <span slot="footer" class="dialog-footer addCard">
                <el-button @click="delShare.delShareFrom = false">{{$t('Cancel')}}</el-button>
                <el-button type="primary" class="selectBtn" style="margin-left: 60px !important" :loading="delShare.delBtnState === 1" @click="delShareSetting">{{$t('Confirm')}}</el-button>
            </span>
        </el-dialog>
        <div class="noSipsettings" v-show="shareList.hasNoShare">{{$t('NoData')}}!</div>
        <template>
            <el-table
            v-show="!shareList.hasNoShare"
            :data="shareList.shareUserList"
            :cell-class-name="getServerStatusClass"
            style="width: 100%;"
            :header-cell-style="{background:'#EDEFFB',color:'#4D4D4F'}"
            >
                <el-table-column
                    label="#"
                    type="index"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="toAccount"
                    :label="$t('ShareAccount')"
                    width="300"
                    >
                </el-table-column>
                <el-table-column
                    prop="toNickname"
                    :label="$t('Alias')"
                    width="300"
                    >
                </el-table-column>
                <el-table-column
                    prop="shareStatus"
                    :label="$t('Status')"
                    width="300"
                    >
                    <template slot-scope="scope">
                        {{handUserShareStatus(scope.row.shareStatus)}}
                    </template>
                </el-table-column>
                <el-table-column width="150"  label="..." align="center">
                    <template slot-scope="scope">
                        <el-image :src="shareList.deleteImg" :title="$t('Delete')"  @click="openDelShareFrom(scope.row)" style="width:24px;" fit="fill"></el-image>
                        <el-image v-show="scope.row.shareStatus === 1 || scope.row.shareStatus === 3 || scope.row.shareStatus === 4" :src="shareList.sharemessage" :title="$t('SendSharingMessage')"  @click="sendSharemessage(scope.row)" style="width:24px;margin-left:1vw;" fit="fill"></el-image>
                    </template>
                </el-table-column>
                <el-table-column>
                </el-table-column>
            </el-table>
        </template>
    </div>
  
</template>

<script>
import QRCode from 'qrcodejs2'
import { mapState } from 'vuex';
import sitesUsersApi from '@/api/siteusers/index.js'
import share from '@/assets/images/share.png'
import sharemessage from '@/assets/images/sharemessage.png'
import search from '@/assets/images/search.png'
import deleteImg from '@/assets/images/delete.png'
export default {
    name:"ShareManagement",
    data(){
        return{
            updateSiteUser:{
                id:"",
                userId:"", //选中用户的用户ID
            },
            shareList:{
                hasNoShare:false,
                shareUserList:[],
                share,
                sharemessage,
                search,
                deleteImg,
            },
            addShare:{
                addShareFrom:false,
                showClose:true,
                shareType:1,//1:账号搜索，2:二维码和连接
                searchHasAcc:0,//0:初始状态,1:搜索到账号，2:为搜索到账号
                searcUserAccount:'',
                userAccount:'',
                nickNam:'',
                userId:'',
                userRegion:'',
                addBtnState:0,
            },
            delShare:{
                delShareFrom:false,
                showClose:true,
                entranceKeyId:"",
                delBtnState:0,
            },
        }
    },
    mounted(){
       this.updateSiteUser.id = this.$route.params.id;
       this.updateSiteUser.userId = this.$route.params.userId;
    //    console.log("this.$route.params",this.$route.params,this.updateSiteUser.id);
    //    console.log("this.$route.params",this.$route.params.userStatus);
    
       //用户状态为1接受，才发获取分享列表的命令
       if(this.$route.params.userStatus === 1){
        //获取Share Management 列表
        this.getSiteUserShareManagementList();
       }
       
    },
    methods:{
        //处理用户分享状态函数
        handUserShareStatus(statu){
            let statuStr = "";
           switch (statu) {
            case 1:
                statuStr = this.$t('PendingAcceptance');
                break;
            case 2:
                statuStr = this.$t('Accepted');
                break;
            case 3:
                statuStr = this.$t('Ignored');
                break;
            case 4:
                statuStr = this.$t('Rejected');
                break;
            case 5:
                statuStr = this.$t('SharerHasDeleted');
                break;
            case 9:
                statuStr = this.$t('Expired');
                break;
            default:
                statuStr = "";
                break;
           }
            return statuStr
        },
      //用户分享状态字体颜色渲染函数
      getServerStatusClass(obj){
            let getClass = "";
            if(obj.column.property === 'shareStatus'){
                let status = obj.row.shareStatus;
                switch(status){
                    case 1:
                        getClass = "statusOrange";
                        break
                    case 2:
                        getClass = "statusGreen";
                        break
                    case 4:
                        getClass = "statusRed";
                        break
                    case 5:
                        getClass = "";
                        break
                    case 9:
                        getClass = "";
                        break
                    default:
                        getClass = "";
                }
                return getClass;
            }
        },
        //获取Share Management 列表
        getSiteUserShareManagementList(){
            let userShareInfoObj = {
                "rgn":this.selectCompany.companyRegion,
                "userHouseId":this.updateSiteUser.id,
                "siteId":this.selectSite.id,
            };
            //解决当前页面刷新后，由于路由参数改变导致updateSiteUser.id获取不到，获取用户密码配置命令出错 code:8
            if(!this.updateSiteUser.id){
                return
            }
            sitesUsersApi.getHouseToShareList(userShareInfoObj).then(res => {
                if(res.code === 0){
                    this.shareList.shareUserList = [];
                    if(res.data === null || res.data.length === 0){
                        this.shareList.shareUserList = [];
                        this.shareList.hasNoShare = true;
                    }else{
                        this.shareList.hasNoShare = false;
                        for(let i=0;i<res.data.length;i++){
                            this.shareList.shareUserList.push(res.data[i]);
                        }
                    }
                }else{
                    this.shareList.shareUserList = [];
                    this.shareList.hasNoShare = true;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                this.shareList.shareUserList = [];
                this.shareList.hasNoShare = true;
                console.log(err);
            })
        },

         //生成分享加入二维码
         createShareQrCode() {
            this.$refs.shareQRCodeBox.innerHTML = '';
            new QRCode(this.$refs.shareQRCodeBox, {
                text: 'test',
                width: 60,
                height: 60,
                colorDark: '#6498b5',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
        },
       
        addShareSetting(){
            this.addShare.addShareFrom = true;
            this.addShare.shareType = 1;
            this.addShare.searchHasAcc = 0
            this.addShare.searcUserAccount = "";
            this.addShare.userAccount = "";
            this.addShare.nickNam = "";
            this.$nextTick(() => {
                this.createShareQrCode();
            });
        },
        //查询用户信息 getUserInfo
        searchUserInfo(){
            if(this.addShare.searcUserAccount === ""){
                this.$message.info(this.$t('AccountNnumberEmpty'));
                return false
            }
            let userInfoObj = {
                "rgn":this.selectCompany.companyRegion,
                "oemGroupId": webConfig.oemGroupId,
                "userAccount": this.addShare.searcUserAccount,
                "siteId":this.selectSite.id,
            };
            sitesUsersApi.getUserInfo(userInfoObj).then(res => {
                if(res.code === 0){
                   this.addShare.searchHasAcc = 1;
                   this.addShare.userAccount = res.data.userAccount;
                   this.addShare.nickNam = res.data.nickName;
                   this.addShare.userId = res.data.userId;
                   this.addShare.userRegion = res.data.userRegion;
                }else{
                    this.$handerrcode(res.code);
                    this.addShare.searchHasAcc = 2;
                    this.addShare.userAccount = "";
                    this.addShare.nickNam = "";
                    this.addShare.userId = "";
                    this.addShare.userRegion = "";
                }
            }).catch((err) => {
                console.log(err);
                this.addShare.searchHasAcc = 2;
                this.addShare.userAccount = "";
                this.addShare.nickNam = "";
                this.addShare.userId = "";
                this.addShare.userRegion = "";
            })
        },
        //分享住宅
        shareHouseTo(){
            let shareHouseRgn = {
                "rgn":this.selectCompany.companyRegion,
            };
            let shareHouseObj = {
                "toUserId":this.addShare.userId,
                "userHouseId":this.updateSiteUser.id,
                "userId":this.updateSiteUser.userId,
                "siteId":this.selectSite.id,
            };
            this.addShare.addBtnState === 1;
            sitesUsersApi.shareHouse(shareHouseRgn,shareHouseObj).then(res => {
                if(res.code === 0){
                    this.addShare.addBtnState === 0;
                    this.$message.success(this.$t('ShareSuccess'));
                    this.addShare.addShareFrom = false;
                    //获取Share Management 列表
                    this.getSiteUserShareManagementList();
                }else{
                    this.addShare.addBtnState === 0;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                this.addShare.addBtnState === 0;
                console.log(err);
            })
        },
        //点击更多分享方式
        moreWaysShare(){
            this.addShare.shareType = 2;
        },
      
        //发送分享消息
        sendSharemessage(item){
            let shareHouseRgn = {
                "rgn":this.selectCompany.companyRegion,
            };
            let shareHouseObj = {
                "toUserId":item.toUserId,
                "userHouseId":this.updateSiteUser.id,
                "userId":this.updateSiteUser.userId,
                "siteId":this.selectSite.id,
            };
            sitesUsersApi.resendShareHouse(shareHouseRgn,shareHouseObj).then(res => {
                if(res.code === 0){
                    this.$message.success(this.$t('ShareSuccess'));
                    //获取Share Management 列表
                    this.getSiteUserShareManagementList();
                    return false
                }else{
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
            })
        },
       
        //取消Share弹窗
        openDelShareFrom(item){
            this.delShare.delShareFrom = true;
            this.delShare.shareId = item.shareId;
        },
        //取消Share 确认
        delShareSetting(){
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            const delSiteUserShareObj = {};
            delSiteUserShareObj.shareId = this.delShare.shareId;
            delSiteUserShareObj.userHouseId = this.updateSiteUser.id;
            delSiteUserShareObj.siteId = this.selectSite.id,
            this.delShare.delBtnState = 1;
            sitesUsersApi.deleteShareHouse(rgnObj,delSiteUserShareObj).then(res => {
                if(res.code === 0){
                    this.delShare.delBtnState = 0;
                    this.$message.success(this.$t('DeleteSuccessfully'));
                    this.delShare.delShareFrom = false;
                    //获取Share Management 列表
                    this.getSiteUserShareManagementList();
                }else{
                    this.delShare.delBtnState = 0;
                    this.$handerrcode(res.code);
                }
                
            }).catch((err) => {
                this.delShare.delBtnState = 0;
                console.log('err', err);
            })
            
        },
    },
    computed:{
        ...mapState(["selectCompany","selectSite"])
    },
    watch:{
      
    }
}
</script>

<style scoped>
.addsiteUersBox{
    display: flex;
    justify-content: center;
    min-height: 220px;
}
::v-deep .shareDialog .el-dialog{
    width: 600px;
}
.searchInputBox{
    position: relative;
    margin-top: 10px;
}
::v-deep .searchInputBox .el-input__inner{
    padding-right: 40px !important;
}
.searchImg{
    width: 26px;
    cursor: pointer;
    position: absolute;
    top: 18px;
    right: 6px;
}
.accountInfo{
    margin-top: 40px;
    padding-bottom: 5px;
    border-bottom: 1px solid #ddd;
    position: relative;
}
.accountInfo span{
    display: inline-block;
    width: 200px;
    white-space: nowrap; /* 保持文本在一行内 */
    overflow: hidden; /* 隐藏超出部分 */
    text-overflow: ellipsis; /* 显示省略号 */
}
.accountInfo span:last-child{
    color: #ccc;
}
.accountNotExit{
    margin-top: 40px;
    padding-bottom: 5px;
}
.shareImg{
    width: 26px;
    cursor: pointer;
    position: absolute;
    top: -6px;
    right: 6px;
}
.moreWays a{
    color: #6498b5;
}
/* .QRCodeBox{
    margin-bottom: 20px;
    border-bottom: 1px solid #ddd;
} */
.QRCodeBoxDiv{
    display: flex;
    justify-content: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
}
.QRCodeBoxLeft{
    width: 80%;
    word-wrap: normal;
    line-height: 1.5;
    padding-right: 20px;
}
.QRCodeBoxRight{
    width: 20%;
    height: 60px;
    padding-left: 20px;
}
.LinkBox{
    margin-top: 40px;
}
.LinkBoxBoxDiv a{
    color: #6498b5;
    text-decoration-line: revert;
}
::v-deep .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 100%;
    border: none;
    background: #EFEFEF;
}
::v-deep .el-form-item__label{
    text-align: left;
}
.addCard .el-button--primary {
    margin-left: 60px !important;
    color: #fff;
    background-color: #6498b5;
    border-color: #6498b5;
}
::v-deep .statusGreen{
    color: green;
}
::v-deep .statusOrange{
    color: orange;
}
::v-deep .statusRed{
    color: red;
}
</style>